<app-template>

    <!-- FAD MASIVO DESKTOP-->
    <div class="fad-desktop" *ngIf="isMobile === false  && isTablet === false">
        <div class="main-payment">
            <p id="confirmacion_compra">
                CONFIRMACIÓN DE COMPRA
            </p>
        </div>

        <div class="info">
            <p class="max-width"> Tu orden<span> ha sido confirmada</span></p>
        </div>

        <div class="payment-content">
            <div class="container max-width">
                <div class="header">
                </div>

                <mat-divider></mat-divider>

                <div class="description-product">
                    <div class="description">
                        <p class="semi" *ngFor="let product of products">
                            - {{product.product}} - {{product.subscription}}
                        </p>
                        <p>La compra de tus productos ha sido confirmada y en breve será activada. Revisa tu orden de
                            compra en tu
                            correo electrónico.</p>
                    </div>
                    <div class="image">
                    </div>
                </div>

                <div class="line-steps">
                    <div class="step active"></div>
                    <div class="step active"></div>
                    <div class="step active"></div>
                    <div class="step active"></div>
                </div>

                <div class="info-purchase data-purchase-item">
                    <p class="title">INFORMACIÓN DE LA CUENTA</p>
                    <div class="items">
                        <div class="item">
                            <p class="name">NOMBRE</p>
                            <p class="value">{{userData?.name}} {{userData?.lastName}}</p>
                        </div>
                        <div class="item">
                            <p class="name">MAIL REGISTRADO</p>
                            <p class="value">{{userData?.email}}</p>
                        </div>
                        <div class="item">
                            <p class="name">TIPO DE PRODUCTO</p>
                            <p class="value">{{userData.isCompany ? 'EMPRESA' : 'PERSONAL'}}</p>
                        </div>
                    </div>
                </div>

                <div class="info-purchase data-purchase-item" *ngIf="billingData !== null && billingData !== ''">
                    <p class="title">Información de facturación</p>
                    <div class="items">
                        <div class="item">
                            <p class="name">País</p>
                            <p class="value">{{billingData?.country}}</p>
                        </div>
                        <div class="item">
                            <p class="name">Estado</p>
                            <p class="value">{{billingData?.state}}</p>
                        </div>
                        <div class="item">
                            <p class="name">Ciudad</p>
                            <p class="value">{{billingData?.city}}</p>
                        </div>
                        <div class="item">
                            <p class="name">Código Postal</p>
                            <p class="value">{{billingData?.code}}</p>
                        </div>
                        <div class="item middle">
                            <p class="name">Dirección</p>
                            <p class="value">{{billingData?.address}}</p>
                        </div>
                        <div class="item middle">
                            <p class="name" *ngIf="this.sessionService.getCountryData()">RFC</p>
                            <p class="name" *ngIf="!this.sessionService.getCountryData()">TAX CODE / IDENTIFICADOR FISCAL</p>
                            <p class="value">{{billingData?.rfc}}</p>
                        </div>
                    </div>
                </div>

                <div class="products-summary">
                    <p class="title">
                        Información de los productos
                    </p>
                    <div class="table">
                        <div class="header">
                            <p class="w-40">Producto</p>
                            <p>Precio</p>
                            <p>Cantidad</p>
                            <p>Total</p>
                        </div>
                        <hr style="width: 100%; border: 2px solid grey; border-radius: 5px; margin-top: -20px">
                        <div class="product" *ngFor="let product of products">
                            <div class="principal">
                                <div class="column w-40">
                                    <p class="semi">
                                        {{product.product}} - {{product.subscription}}
                                    </p>
                                    <p>
                                        {{product.usuarios}} {{product.usuariosLabel}} - {{product.transactions}}
                                        - {{product.transactionType}}
                                    </p>
                                </div>
                                <div class="column">
                                    <p class="semi">
                                        <span>${{ getPriceCentavos(product.pricing) | formatoMil }} {{product.pricingInfo}}</span>
                                    </p>
                                </div>
                                <div class="column">
                                    <p class="semi">
                                        {{product.quantity}}
                                    </p>
                                </div>
                                <div class="column">
                                    <p class="semi">
                                        <span>${{getPriceCentavos(product.quantity * product.pricing)  | formatoMil }} {{product.pricingInfo}}</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <mat-divider></mat-divider>
                    <p style="font-size:20px ;text-align: center; padding: 20px; font-family: 'Montserrat-Bold', sans-serif" *ngIf="getTotalDescuento() !== null">
                        “Se aplico un descuento en esta compra por el código que ingresaste en el paso anterior.”
                    </p>
                    <p class="total" *ngIf="this.sessionService.getCountryData()">
                        <span>Subtotal: $ {{ getTotalDescuento() === null ? getTotal() : getTotalDescuento() | formatoMil }}</span> MXP
                    </p>
                    <p class="total" *ngIf="this.sessionService.getCountryData()">
                        <span>IVA: $ {{ getTotalDescuento() === null ? getIVA(getTotal() * .16) : getIVA(getTotalDescuento() * .16) | formatoMil }}</span> MXP
                    </p>
                    <p class="total" *ngIf="this.sessionService.getCountryData()">
                        <span>Total: $ {{ getTotalDescuento() === null ? getTotalIVA(getTotal(1)) : getTotalIVA(getTotalDescuento()) | formatoMil }}</span> MXP
                    </p>
                    <p class="total" *ngIf="!this.sessionService.getCountryData()">
                        <span>Total: $ {{ getTotalDescuento() === null ? getTotalIVA(getTotal(1)) : getTotalIVA(getTotalDescuento())}}</span> USD
                    </p>
                    <div id="confirmacion_pago_backoffice" class="button" (click)="goToBackOffice()">
                        ENTRA A TU CUENTA
                    </div>
                </div>
            </div>
            <br>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" *ngIf="isMobile === true  || isTablet === true">
        <div class="box-container">
            <div class="box-img">
                <img class="img-prin" src="assets/images/m/personalfotos.png">
            </div>
            <div class="content-res" id="confirmacion_compra_movil">
                CONFIRMACIÓN DE COMPRA
                <p class="text">
                    Tu orden <strong>ha sido confirmada</strong>
                </p>
                <p class="text" *ngFor="let product of products">
                    - {{product.product}} - {{product.subscription}}
                </p>
                <p class="text">La compra de tus productos ha sido confirmada y en breve será activada. Revisa tu orden
                    de
                    compra en tu
                    correo electrónico.</p>
            </div>
            <mat-divider></mat-divider>

            <div class="content-res" *ngIf="userData !== null && userData !== ''">
                INFORMACIÓN DE LA CUENTA
                <div class="text">
                    <p class="value">Nombre: <br><span>{{userData?.name}} {{userData?.lastName}}</span></p>
                </div>
                <div class="text">
                    <p class="value">Mail registrado: <br><span>{{userData?.email}}</span></p>
                </div>
                <div class="text">
                    <p class="value">Tipo de producto:
                        <span>{{userData.isCompany ? 'EMPRESA' : 'PERSONAL'}}</span></p>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="content-res" *ngIf="billingData !== null && billingData !== ''">
                INFORMACIÓN DE FACTURACIÓN
                <div class="text">
                    <p class="value">País: <span>{{billingData?.country}}</span></p>
                </div>
                <div class="text">
                    <p class="value">Estado: <br><span>{{billingData?.state}}</span></p>
                </div>
                <div class="text">
                    <p class="value">Ciudad: <br><span>{{billingData?.city}}</span></p>
                </div>
                <div class="text">
                    <p class="value">Código Postal: <span>{{billingData?.code}}</span></p>
                </div>
                <div class="text">
                    <p class="value">Dirección: <br><span>{{billingData?.address}}</span></p>
                </div>
                <div class="text">
                    <p class="value" *ngIf="this.sessionService.getCountryData()">RFC: <span>{{billingData?.rfc}}</span></p>
                    <p class="value" *ngIf="!this.sessionService.getCountryData()">TAX CODE / IDENTIFICADOR FISCAL: <span>{{billingData?.rfc}}</span></p>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="content-res">
                INFORMACIÓN <span>DE LOS PRODUCTOS</span>
                <br>
                <div class="box-product" style="font-size: 20px; margin-top: 20px">
                    <p class="title-header" style="padding-left: 30px">Paquete:</p>
                    <mat-divider class="margin-plus" style="background: white"></mat-divider>
                    <ng-container *ngFor="let x of products.length | fill ; let i = index">
                        <div class="products">
                            <div class="check-product">
                                <p><span>{{products[i].product}}</span> - {{products[i].subscription}}:</p>
                                <p class="price" >$ {{getPriceCentavos(products[i].pricing) | formatoMil }} {{products[i].pricingInfo}}</p>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <mat-divider></mat-divider>
            <p style="font-size:18px ;text-align: center; padding: 20px; font-family: 'Montserrat-Bold', sans-serif" *ngIf="getTotalDescuento() !== null">
                “Se aplico un descuento en esta compra por el código que ingresaste en el paso anterior.”
            </p>
            <div class="content-res">
                <div class="final-price" *ngIf="this.sessionService.getCountryData()">
                    <p>Subtotal: </p>
                    <p><span>$ {{ getTotalDescuento() === null ? getTotal() : getTotalDescuento() | formatoMil }} MXP </span></p>
                </div>
                <div class="final-price" *ngIf="this.sessionService.getCountryData()">
                    <p>IVA: </p>
                    <p><span>$ {{ getTotalDescuento() === null ? getIVA(getTotal() * .16) : getIVA(getTotalDescuento() * .16) | formatoMil }} MXP </span></p>
                </div>
                <div class="final-price" *ngIf="this.sessionService.getCountryData()">
                    <p>Total: </p>
                    <p><span>$ {{ getTotalDescuento() === null ? getTotalIVA(getTotal(1)) : getTotalIVA(getTotalDescuento()) | formatoMil }} MXP </span></p>
                </div>
                <div class="final-price" *ngIf="!this.sessionService.getCountryData()">
                    <p>Total: </p>
                    <p><span>$ {{ getTotalDescuento() === null ? getTotalIVA(getTotal(1)) : getTotalIVA(getTotalDescuento())}} USD </span></p>
                </div>
            </div>
            <p style="font-size:15px ;text-align: center; padding: 0 20px; font-family: 'Montserrat-Light', sans-serif">
                “Para comenzar a utilizar tus transacciones inicia sesión en <span
                    style="cursor: pointer; font-family: 'Montserrat-SemiBold', sans-serif"><a id="confirmacion_pago_backoffice_movil"
                    (click)="goToBackOffice()">Portal de clientes</a></span> desde tu
                computadora de escritorio o sólo da click en el link que se encuentra en el mail de
                confirmación de compra.”
            </p>
            <br>
        </div>
    </div>

</app-template>
